<template>
  <div class="users-list" :class="{ 'is-suspended': isSuspended }">
    <div class="table-header text-black bg-white rounded shadow px-6 py-4 mt-1 flex items-center">
      <div class="flex-one item-color w-2/5 mr-4">
        <div class="flex items-center">
          <div>
            <div
              v-if="userList.pictureId === ''"
              :style="bagroundDefine"
              class="float-left w-8 h-8 text-center pt-2 -mt-1 mr-2 rounded-full first-letter-section text-sm font-bold text-white"
            >
              <div v-if="userList.firstName === ''">{{ getFirstLetter(userList.pseudo) }}</div>
              <div v-else>{{ getFirstLetter(userList.firstName + ' ' + userList.lastName) }}</div>
            </div>
            <div v-else v-bind:style="{ 'background-image': 'url(' + picture + ')' }" class="bg-no-repeat bg-cover w-8 h-8 pt-2 -mt-1 mr-2 rounded-full"></div>
          </div>
          <div class="name break-all">
            <div v-if="userList.firstName === ''">{{ userList.pseudo }}</div>
            <div v-else>{{ userList.firstName + ' ' + userList.lastName }}</div>
            <div v-if="isSuspended" class="suspended-badge text-red-600 text-xs font-bold mt-1">Suspendu</div>
          </div>
        </div>
      </div>
      <div class="flex-one item-color w-1/5">
        <div v-if="userList.phone === null">-</div>
        <div v-else>{{ userList.phone.substr(4) }}</div>
      </div>
      <!-- <div class="flex-one item-color w-1/3 mr-4">
        <div v-if="userList.user.lastLogin === null">-</div>
        <div v-else>
        {{ new Intl.DateTimeFormat('fr-FR').format(new Date(userList.user.lastLogin)) }}
        </div>
      </div> -->
      <div class="flex-one item-color w-1/12">
        <div v-if="userList.sexe === null">-</div>
        <div v-else>{{ userList.sexe }}</div>
      </div>
      <div class="flex-one item-color w-1/4">
        {{ userList.profession !== '' ? userList.profession : '-' }}
      </div>
      <div class="flex-one item-color w-1/4">
        <div
          class="benin py-2 px-4 rounded-full"
          :style="backgroundDefine"
        >
          <div v-if="userList.location === ''">
            <div v-if="userList.town === ''">-</div>
            <div v-else>{{ userList.town }}</div>
          </div>
          <div v-else>{{ userList.location }}</div>
        </div>
      </div>
      <div class="flex-one item-color w-1/4 break-all">
        {{ truncateString(userList.pseudo, 15) }}
      </div>
      <div class="flex-one item-color w-1/4">
        {{ new Intl.DateTimeFormat('fr-FR').format(new Date(userList.user.lastLogin)) }}
      </div>
      <div class="flex-one item-color w-1/4">
      {{ parrainage }}
      </div>
      <div class="flex-one item-color w-1/12">
        <button
          v-if="!isSuspended"
          class="promote-btn px-3 py-2 rounded text-white text-xs font-semibold"
          @click.stop="$emit('promoteUser', userList)"
        >
          Promouvoir
        </button>
        <button
          v-else
          class="reactivate-btn px-3 py-2 rounded text-white text-xs font-semibold"
          @click.stop="onReactivate"
        >
          Réactiver
        </button>
      </div>
      <div ref="menuWrap" class="w-10 flex items-center justify-end relative ml-2">
        <div
          v-if="!isSuspended"
          class="menu-trigger cursor-pointer px-2 py-1 rounded hover:bg-gray-100 text-xl font-bold text-gray-600"
          @click.stop="toggleMenu"
        >
          ⋮
        </div>
        <div v-if="menuOpen && !isSuspended" class="menu-dropdown absolute right-0 mt-2 bg-white shadow-lg rounded border z-50">
          <div
            class="menu-item px-4 py-2 cursor-pointer text-red-600 hover:bg-gray-100 whitespace-nowrap"
            @click.stop="onSuspend"
          >
            Suspendre
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/plugins/http'
import apiroutes from '@/router/api-routes'

export default {
  name: 'users-list',
  props: {
    userList: {
      type: Object,
      default: function () {
        return {}
      }
    },
    parrainage: {
      type: Number,
      default: 0
    },
    viewMode: {
      type: String,
      default: 'active'
    }
  },
  data () {
    return {
      picture: '',
      imgBase: 'data:image/jpeg;base64,',
      name: this.userList.firstName + ' ' + this.userList.lastName,
      bagroundDefine: {
        backgroundColor: '#000000'
      },
      backgroundDefine: {
        backgroundColor: '#000000'
      },
      menuOpen: false
    }
  },
  computed: {
    isSuspended () {
      if (this.viewMode === 'inactive') return true
      const u = (this.userList && this.userList.user) || this.userList || {}
      return u.isSuspended === true || u.suspended === true || u.status === 'SUSPENDED'
    }
  },
  mounted () {
    document.addEventListener('mousedown', this.handleClickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('mousedown', this.handleClickOutside)
  },
  created () {
    // console.log(this.userList)
    const colors = ['#01C8C8', '#FFA83D', '#6D1FEB', '#2F80ED', '#0DCE89', '#7D47B3', '#1ECC78', '#C1CD18', '#581845', '#000080']
    const value = Math.floor(Math.random() * (colors.length + 1))
    if (value < colors.length) {
      this.bagroundDefine.backgroundColor = colors[value]
    } else {
      this.bagroundDefine.backgroundColor = colors[0]
    }
    this.townBackground()
    this.getUserPicture()
  },
  methods: {
    getUserPicture () {
      if (this.userList.pictureId !== '') {
        http.get(apiroutes.baseURL + apiroutes.getFileById + this.userList.pictureId, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.loginToken}`
          }
        })
          .then(response => {
            // console.log(response)
            this.picture = this.imgBase + response.file
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    townBackground () {
      const colors = ['rgba(1,101,200,0.1)', 'rgba(0,169,88,0.1)', 'rgba(255,168,61,0.1)', 'rgba(0,169,88,0.1)', 'rgba(1,101,200,0.1)']
      const value = Math.floor(Math.random() * (colors.length + 1))
      if (value < colors.length) {
        this.backgroundDefine.backgroundColor = colors[value]
      } else {
        this.backgroundDefine.backgroundColor = colors[0]
      }
    },
    getFirstLetter (fullname) {
      const nameTable = fullname.split(' ')
      if (nameTable.length >= 2) {
        return nameTable[0].charAt(0).toUpperCase() + nameTable[1].charAt(0).toUpperCase()
      } else {
        return nameTable[0].charAt(0).toUpperCase() + nameTable[0].charAt(1).toUpperCase()
      }
    },
    truncateString (str, num) {
      if (str.length <= num) {
        return str
      }
      return str.slice(0, num) + '...'
    },
    toggleMenu () {
      this.menuOpen = !this.menuOpen
    },
    handleClickOutside (event) {
      if (this.menuOpen) {
        const wrap = this.$refs.menuWrap
        if (wrap && !wrap.contains(event.target)) {
          this.menuOpen = false
        }
      }
    },
    onSuspend () {
      this.menuOpen = false
      this.$emit('suspendUser', this.userList)
    },
    onReactivate () {
      this.menuOpen = false
      this.$emit('reactivateUser', this.userList)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "src/assets/style/sass/variables";
  .table-header:hover {
    background: rgba(1,101,200,0.1);
    border-left: 2px solid $pass_marron;
    box-shadow: -6px 0px 6px 0px rgba(51, 50, 50, 0.45);
  }
  .benin {
    width: fit-content;
  }
  .promote-btn {
    background-color: $pass_marron;
    transition: opacity 0.2s;
    &:hover {
      opacity: 0.85;
    }
  }
  .reactivate-btn {
    background-color: #16a34a;
    transition: opacity 0.2s;
    &:hover {
      opacity: 0.85;
    }
  }
  .is-suspended {
    .table-header {
      background-color: rgba(196, 58, 43, 0.05);
      opacity: 0.75;
    }
    .name > div:not(.suspended-badge) {
      text-decoration: line-through;
      color: #6b7280;
    }
  }
  .menu-dropdown {
    top: 100%;
    min-width: 9rem;
  }
</style>
